module.exports = __webpack_public_path__ + "static/img/bg-pt.5132844b.png";